// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3yowP","loaderOuter":"PageOverlayLoader_loaderOuter__3owh2"};